import { AsyncResponseData } from "./fetchWrapper/fetchWrapper";
import { RESOURCES_KEYS } from "./i18n/resources";

export const debounce = <F extends (...args: any[]) => any>(func: F, waitFor: number) => {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  const debounced = (...args: Parameters<F>) => {
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
    timeout = setTimeout(() => func(...args), waitFor);
  };

  return debounced as (...args: Parameters<F>) => ReturnType<F>;
};

export const formatDateToFranchDate = (date: string) => {
  const utcDate  = new Date(date);
  return utcDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'numeric', year: 'numeric'})
};

export const computeErrorMessage = <T>(AsyncResponseError?: AsyncResponseData<T>['error']): string => {
  return AsyncResponseError?.type ?? AsyncResponseError?.detail ?? RESOURCES_KEYS.API_ERROR_AN_ERROR_HAS_OCCURRED;
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export const stringOrEmpty = (input?: string) => input ?? '';
